export default "__VITE_ASSET__d7be4169__"